import { render, staticRenderFns } from "./Roster.vue?vue&type=template&id=01208402&scoped=true&"
import script from "@/views/Roster/Roster.ts?vue&type=script&lang=ts&"
export * from "@/views/Roster/Roster.ts?vue&type=script&lang=ts&"
import style0 from "@/views/Roster/roster.scss?vue&type=style&index=0&id=01208402&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01208402",
  null
  
)

export default component.exports